import request from '@/utils/request'

// 账号密码登录
export function login(data) {
  return request({
    url:  `/login`,
    method: 'post',
    data
  })
}
// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 获取
export function getVeryCode(data) {
  return request({
    url:  `/login`,
    method: 'post',
    data
  })
}
// 获取个人信息
export function getInfo(id) {
  return request({
    url:  `/system/user/${id}`,
    method: 'get',
  })
}

// 获取客户信息
export function getCustomerInfo(id) {
  return request({
    url:  `/v1/fiveUser/getFiveUserById?userId=${id}`,
    method: 'get',
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取省份
export function getProvince(data) {
  return request({
    url: '/v1/area/get',
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js